import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import ImageUploader from './ImageUploader';
import WebCamComponent from './WebCamComponent';
import ImagePicker from './ImageUploader';
import TextInput from '../InputComponent/TextInput';
import SelectInput from '../InputComponent/SelectInput';
import TextAreaInput from '../InputComponent/TextAreaInput';

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const PersonalDetailsStep = ({ data, onNext }) => {
    const [formData, setFormData] = useState(data);

    useEffect(() => {
        setFormData(data)
    }, [data])
    const [preview, setPreview] = useState(null);
    const [base64Img, setBase64Img] = useState(null); 
 

    const handleImageSelect = (e) => {
        const selected = e.target.files[0];
        if (!selected) return;
 
        if (!["image/jpg", "image/jpeg"].includes(selected.type)) {
            alert("Only JPG images are allowed.");
            return;
        }
 
        setPreview(URL.createObjectURL(selected));

        // ✅ Compress Image
        const reader = new FileReader();
        reader.readAsDataURL(selected);

        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;

            img.onload = () => {
                const canvas = document.createElement("canvas");
                const MAX_WIDTH = 600;   
                const MAX_HEIGHT = 600; 

                let width = img.width;
                let height = img.height; 

                if (width > height) {
                    if (width > MAX_WIDTH) {
                        height *= MAX_WIDTH / width;
                        width = MAX_WIDTH;
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                        width *= MAX_HEIGHT / height;
                        height = MAX_HEIGHT;
                    }
                }

                canvas.width = width;
                canvas.height = height;

                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);

                // ✅ Compress to 70% JPG
                const compressedBase64 = canvas.toDataURL("image/jpeg", 0.7);

                setBase64Img(compressedBase64);
                setFormData(prev=> ({...prev, base64Img : compressedBase64 }))

                console.log("Compressed Size (KB):", Math.round((compressedBase64.length * 3) / 4 / 1024));
            };
        };
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name == "contact") {
            const digits = value.replace(/\D/g, ""); 
            setFormData(prev => ({ ...prev, [name]: digits }));
            return;
        }

        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleContinue = () => {
        // if (!formData.name || !formData.contact || !formData.email || !formData.dob) {
        if (!formData.name) {
            toast.error('Please enter a Full name.');
            return;
        }
        if (!formData.contact) {
            toast.error('Please enter a valid contact number.');
            return;
        }
        if (formData.contact.length < 7 ||( formData.emergencyContactPhone != ''&& formData.emergencyContactPhone.length < 7)) {
            toast.error('Please enter at least 7 digit mobile number');
            return;
        }
        if (formData.contact.length > 11 || formData.emergencyContactPhone.length > 11) {
            toast.error('Mobile number cannot exceed 11 digits');
            return;
        }
        if (!formData.email || !emailRegex.test(formData.email)) {
            toast.error('Please enter a valid Email Address.');
            return;
        }
        onNext({ personal: formData });
    };

    return (
        <div className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-800">1. Personal Details</h3>
            <ImagePicker preview={preview} onSelect={handleImageSelect} />
            <TextInput label={"Full Name"} name="name" value={formData.name} onChange={handleChange} type="text" isRequired={true} />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <TextInput label={"Date of Birth"} name="dob" type="date" value={formData.dob} onChange={handleChange} />
                <TextInput label={"Contact Number"} type="tel" maxLength={7} inputMode="numeric" name="contact" value={formData.contact} isRequired={true} onChange={handleChange} />
                <TextInput label={"Email Address"} type="email" name="email" value={formData.email} onChange={handleChange} isRequired={true}/>
                <SelectInput
                    label="Gender"
                    name="gender"
                    value={formData.gender} onChange={handleChange}
                    isRequired={true}
                >
                    <option>Male</option>
                    <option>Female</option>
                    <option>Other</option>
                </SelectInput> 
                <TextInput label={"Emergency Contact Name"} type="text" name="emergencyContactName" value={formData.emergencyContactName} onChange={handleChange} />
                <TextInput label={"Emergency Contact Phone"} type="number" name="emergencyContactPhone" value={formData.emergencyContactPhone} onChange={handleChange} />
                <TextAreaInput label={"Address"}  type="text" name="address" value={formData.address} onChange={handleChange}/> 
            </div>
            <div className="pt-4 flex justify-end">
                <button onClick={handleContinue} className="px-6 py-2 bg-brand-red text-white rounded-lg hover:bg-red-600">Save & Continue</button>
            </div>
        </div>
    );
};

export default PersonalDetailsStep;
